/**
 * Contact Form Validation
 * فاليديشن عصري للفورم بتاع التواصل - realtime + submit
 */
(function () {
    'use strict';

    const form = document.getElementById('contactForm');
    if (!form) return;

    const submitBtn = document.getElementById('contactSubmitButton');
    const statusEl = document.getElementById('contactFormStatus');
    const captchaTokenInput = document.getElementById('contact_captcha_token');
    const hasRecaptcha = !!document.querySelector('.g-recaptcha');

    // -------- إعدادات الفاليديشن لكل حقل --------
    const rules = {
        contact_name: {
            required: true,
            minLength: 2,
            maxLength: 150,
            messages: {
                required: 'من فضلك اكتب اسمك',
                minLength: 'الاسم لازم يكون حرفين على الأقل',
                maxLength: 'الاسم طويل جدًا'
            }
        },
        contact_email: {
            required: true,
            maxLength: 254,
            pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            messages: {
                required: 'من فضلك اكتب بريدك الإلكتروني',
                pattern: 'البريد الإلكتروني مش صحيح',
                maxLength: 'البريد الإلكتروني طويل جدًا'
            }
        },
        subject: {
            required: true,
            minLength: 3,
            maxLength: 255,
            messages: {
                required: 'من فضلك اكتب عنوان الرسالة',
                minLength: 'العنوان قصير جدًا',
                maxLength: 'العنوان طويل جدًا'
            }
        },
        contact_phone: {
            required: false,
            pattern: /^[+0-9\s-]{6,30}$/,
            messages: {
                pattern: 'رقم الهاتف مش صحيح'
            }
        },
        contact_message: {
            required: true,
            minLength: 10,
            maxLength: 5000,
            messages: {
                required: 'من فضلك اكتب رسالتك',
                minLength: 'الرسالة قصيرة جدًا، اكتب 10 حروف على الأقل',
                maxLength: 'الرسالة طويلة جدًا'
            }
        }
    };

    // -------- إنشاء عنصر رسالة الخطأ تحت كل حقل --------
    function ensureFeedbackEl(field) {
        let feedback = field.parentElement.querySelector('.field-feedback');
        if (!feedback) {
            feedback = document.createElement('div');
            feedback.className = 'field-feedback';
            field.parentElement.appendChild(feedback);
        }
        return feedback;
    }

    function setFieldState(field, state, message) {
        const feedback = ensureFeedbackEl(field);
        field.classList.remove('is-valid', 'is-invalid');
        if (state === 'valid') {
            field.classList.add('is-valid');
            feedback.textContent = '';
            feedback.classList.remove('show');
        } else if (state === 'invalid') {
            field.classList.add('is-invalid');
            feedback.textContent = message || '';
            // إعادة تشغيل الأنيميشن
            feedback.classList.remove('show');
            void feedback.offsetWidth;
            feedback.classList.add('show');
        } else {
            feedback.textContent = '';
            feedback.classList.remove('show');
        }
    }

    function validateField(field) {
        const rule = rules[field.id];
        if (!rule) return true;

        const value = field.value.trim();

        if (rule.required && value.length === 0) {
            setFieldState(field, 'invalid', rule.messages.required);
            return false;
        }

        // حقل اختياري وفاضي = صحيح
        if (!rule.required && value.length === 0) {
            setFieldState(field, null);
            return true;
        }

        if (rule.minLength && value.length < rule.minLength) {
            setFieldState(field, 'invalid', rule.messages.minLength);
            return false;
        }

        if (rule.maxLength && value.length > rule.maxLength) {
            setFieldState(field, 'invalid', rule.messages.maxLength);
            return false;
        }

        if (rule.pattern && !rule.pattern.test(value)) {
            setFieldState(field, 'invalid', rule.messages.pattern);
            return false;
        }

        setFieldState(field, 'valid');
        return true;
    }

    function validateAll() {
        let allValid = true;
        Object.keys(rules).forEach(function (id) {
            const field = document.getElementById(id);
            if (field && !validateField(field)) {
                allValid = false;
            }
        });
        return allValid;
    }

    // -------- ربط الأحداث: تحقق فوري مع debounce --------
    let debounceTimers = {};
    Object.keys(rules).forEach(function (id) {
        const field = document.getElementById(id);
        if (!field) return;

        // بعد ما المستخدم يسيب الحقل، تحقق فورًا
        field.addEventListener('blur', function () {
            validateField(field);
        });

        // أثناء الكتابة، تحقق بعد توقف بسيط (عشان ميبانش عصبي)
        field.addEventListener('input', function () {
            clearTimeout(debounceTimers[id]);
            // لو الحقل already invalid، صححله بسرعة أول ما يظبط
            const wasInvalid = field.classList.contains('is-invalid');
            debounceTimers[id] = setTimeout(function () {
                validateField(field);
            }, wasInvalid ? 200 : 500);
        });
    });

    // -------- ريكابتشا --------
    function updateSubmitAvailability() {
        const captchaOk = !hasRecaptcha || (captchaTokenInput && captchaTokenInput.value.length > 0);
        submitBtn.disabled = !captchaOk;
    }

    window.contactCaptchaChanged = function (token) {
        if (captchaTokenInput) captchaTokenInput.value = token || '';
        updateSubmitAvailability();
    };

    window.contactCaptchaExpired = function () {
        if (captchaTokenInput) captchaTokenInput.value = '';
        updateSubmitAvailability();
    };

    if (!hasRecaptcha) {
        // لو مفيش ريكابتشا، فعّل الزرار عادي
        updateSubmitAvailability();
    }

    // -------- حالة الإرسال --------
    function showStatus(type, message) {
        statusEl.textContent = message;
        statusEl.className = 'mt-3 status-' + type;
        statusEl.classList.add('show');
    }

    function clearStatus() {
        statusEl.textContent = '';
        statusEl.className = 'mt-3';
    }

    function setLoading(isLoading) {
        if (isLoading) {
            submitBtn.dataset.originalText = submitBtn.textContent;
            submitBtn.disabled = true;
            submitBtn.classList.add('is-loading');
            submitBtn.innerHTML = '<span class="btn-spinner"></span> جارِ الإرسال...';
        } else {
            submitBtn.classList.remove('is-loading');
            submitBtn.innerHTML = submitBtn.dataset.originalText || 'إرسال الرسالة';
            updateSubmitAvailability();
        }
    }

    // -------- الإرسال --------
    form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearStatus();

        const isValid = validateAll();

        if (hasRecaptcha && (!captchaTokenInput || !captchaTokenInput.value)) {
            showStatus('error', 'من فضلك أكّد إنك مش روبوت.');
            return;
        }

        if (!isValid) {
            // ركّز أول حقل فيه خطأ
            const firstInvalid = form.querySelector('.is-invalid');
            if (firstInvalid) {
                firstInvalid.focus();
                firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            showStatus('error', 'في بيانات محتاجة تتصحح قبل الإرسال.');
            return;
        }

        const endpoint = form.dataset.endpoint;
        const formData = new FormData(form);

        setLoading(true);

        fetch(endpoint, {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
            .then(function (res) {
                return res.json().catch(function () { return { success: res.ok }; });
            })
            .then(function (data) {
                setLoading(false);
                if (data && data.success) {
                    showStatus('success', data.message || 'تم إرسال رسالتك بنجاح، هنتواصل معاك قريبًا.');
                    form.reset();
                    Object.keys(rules).forEach(function (id) {
                        const field = document.getElementById(id);
                        if (field) setFieldState(field, null);
                    });
                    if (captchaTokenInput) captchaTokenInput.value = '';
                    if (window.grecaptcha) window.grecaptcha.reset();
                    updateSubmitAvailability();
                } else {
                    showStatus('error', (data && data.message) || 'حصل خطأ أثناء الإرسال، حاول تاني.');
                }
            })
            .catch(function () {
                setLoading(false);
                showStatus('error', 'حصلت مشكلة في الاتصال، تأكد من النت وحاول تاني.');
            });
    });
})();
